
export enum DumpTruckStatusTypes {
    ACTIVE = 1,
    UNLOADED = 2,
    PENDING = 3,
}

export enum DumpTruckTypeTypes {
    REMOVAL = 1, // Retiro
    DEBRIS = 2,  // Escombro
}
